import React, { useState, useEffect } from "react";
import HomeCards from "../HomePage/Chartjs/HomeWidget";
import HomeCharts from "../HomePage/Chartjs/HomeCharts";
import HomeBarCharts from "../HomePage/Chartjs/HomeBarCharts";
import TahsilatPlan from "../HomePage/Lists/TahsilatPlanLists";
import { useMediaQuery } from "react-responsive";
import { Tabs, Row, Col, Spin } from "antd";
import { HomeOutlined } from "@ant-design/icons";
import RequestHandler from "../../util/RequestHandler";

const ChartsReport = () => {
  const isDesktopOrLaptop = useMediaQuery({
    query: "(min-device-width: 1224px)",
  });
  const isTabletOrMobileDevice = useMediaQuery({
    query: "(max-device-width: 1224px)",
  });

  const [currencyTRY, setCurrencyTRY] = useState(0);
  const [currencyTRList, setCurrencyTRList] = useState([]);
  const [CollectAndPaymentChartTRY, setCollectAndPaymentChartTRY] = useState(
    []
  );
  const [MonthlyAccountTRY, setMonthlyAccountTRY] = useState([]);
  const [CollectListTRY, setCollectListTRY] = useState([]);
  const [PaymentListTRY, setPaymentListTRY] = useState([]);
  const [TotalPaymentTRY, setTotalPaymentTRY] = useState([]);
  const [TotalCollectTRY, setTotalCollectTRY] = useState([]);
  const [activeKey, setActiveKey] = useState("1");
  const [loading, setLoading] = useState(true);
  const [availableBalanceTRY, setAvailableBalanceTRY] = useState("");

  useEffect(() => {
    RequestHandler.get(
      `/TenantCurrency?$apply=groupby((Currency,CurrencyId))&$orderby=currencyId`
    ).then((response) => {
      setCurrencyTRList(response);
      setActiveKey(response[0]?.currencyId.toString());
    });

    RequestHandler.get(`/Reports/GetMonthlyCollectAndPayment/1`).then((res) => {
      setCollectAndPaymentChartTRY(res);
    });

    RequestHandler.get(`/Reports/GetTotalAmountByCurrencyId/1`).then((res) => {
      setCurrencyTRY(res);
    });

    RequestHandler.get(`/Reports/GetTotalCollectByCurrencyId/1`).then(
      (response) => {
        setTotalCollectTRY(response);
      }
    );

    RequestHandler.get(`/Reports/GetTotalPaymentByCurrencyId/1`).then(
      (response) => {
        setTotalPaymentTRY(response);
      }
    );

    RequestHandler.get(`/Reports/GetAvailableBalance/1`).then((response) => {
      setAvailableBalanceTRY(response);
    });

    RequestHandler.get(`/Reports/GetMonthlyAccount/1`).then((res) => {
      setMonthlyAccountTRY(res);
    });

    RequestHandler.get(
      `/Reports/GetMonthlyCollectAndPaymentPlanList?currencyId=1&id=1`
    ).then((res) => {
      setCollectListTRY(res);
    });

    RequestHandler.get(
      `/Reports/GetMonthlyCollectAndPaymentPlanList?currencyId=1&id=2`
    ).then((res) => {
      setPaymentListTRY(res);
      setLoading(false);
    });
  }, []);

  const ContactSideBar = (value) => {
    return isDesktopOrLaptop === true ? (
      <Spin spinning={loading}>
        <div style={{ marginLeft: "1%" }} className="ant-row">
          <HomeCards
            icon="home"
            title={currencyTRY}
            subTitle={value}
            descText="TOPLAM BAKİYE"
          />
          <HomeCards
            icon="long-arrow-up"
            title={TotalCollectTRY}
            subTitle={value}
            descText="GELECEK TAHSİLAT"
            color="green"
          />
          <HomeCards
            icon="long-arrow-down"
            title={TotalPaymentTRY}
            subTitle={value}
            descText="YAPILACAK ÖDEME"
            color="red"
          />
          <HomeCards
            icon="calendar"
            title={availableBalanceTRY}
            subTitle={value}
            descText="TAHMİNİ KALAN BAKİYE"
          />
          <HomeBarCharts chartValues={CollectAndPaymentChartTRY} />
          <HomeCharts chartValues={MonthlyAccountTRY} />

          <Col span={12}>
            <TahsilatPlan
              dataValues={CollectListTRY}
              planType="TAHSİLAT PLANI"
              currencyLogo={""}
            />
          </Col>
          <Col span={12}>
            <TahsilatPlan
              dataValues={PaymentListTRY}
              planType="ÖDEME PLANI"
              currencyLogo={""}
            />
          </Col>
        </div>
      </Spin>
    ) : (
      <Spin spinning={loading}>
        <div className="ant-row">
          <HomeCards
            icon="home"
            title={currencyTRY}
            subTitle={value}
            descText="TOPLAM BAKİYE"
          />
          <HomeCards
            icon="long-arrow-up"
            title={TotalCollectTRY}
            subTitle={value}
            descText="GELECEK TAHSİLAT"
            color="green"
          />
          <HomeCards
            icon="long-arrow-down"
            title={TotalPaymentTRY}
            subTitle={value}
            descText="YAPILACAK ÖDEME"
            color="red"
          />
          <HomeCards
            icon="calendar"
            title={availableBalanceTRY}
            subTitle={value}
            descText="TAHMİNİ KALAN BAKİYE"
          />
          <HomeBarCharts chartValues={CollectAndPaymentChartTRY} />
          <HomeCharts chartValues={MonthlyAccountTRY} />
          <Col span={24}>
            <TahsilatPlan
              dataValues={CollectListTRY}
              planType="TAHSİLAT PLANI"
              currencyLogo={""}
            />
          </Col>
          <Col span={24}>
            <TahsilatPlan
              dataValues={PaymentListTRY}
              planType="ÖDEME PLANI"
              currencyLogo={""}
            />
          </Col>
        </div>
      </Spin>
    );
  };

  const handleChange = (activeKey) => {
    RequestHandler.get(`/Reports/GetTotalAmountByCurrencyId/${activeKey}`).then(
      (res) => {
        setCurrencyTRY(res);
      }
    );

    RequestHandler.get(
      `/Reports/GetMonthlyCollectAndPaymentPlanList?currencyId=${activeKey}&id=2`
    ).then((res) => {
      setPaymentListTRY(res);
    });

    RequestHandler.get(`/Reports/GetAvailableBalance/${activeKey}`).then(
      (response) => {
        setAvailableBalanceTRY(response);
      }
    );

    RequestHandler.get(
      `/Reports/GetMonthlyCollectAndPayment/${activeKey}`
    ).then((res) => {
      setCollectAndPaymentChartTRY(res);
    });

    RequestHandler.get(
      `/Reports/GetTotalCollectByCurrencyId/${activeKey}`
    ).then((response) => {
      setTotalCollectTRY(response);
    });

    RequestHandler.get(`/Reports/GetMonthlyAccount/${activeKey}`).then(
      (res) => {
        setMonthlyAccountTRY(res);
      }
    );

    RequestHandler.get(
      `/Reports/GetTotalPaymentByCurrencyId/${activeKey}`
    ).then((response) => {
      setTotalPaymentTRY(response);
    });

    RequestHandler.get(
      `/Reports/GetMonthlyCollectAndPaymentPlanList?currencyId=${activeKey}&id=1`
    ).then((res) => {
      setCollectListTRY(res);
    });
    setActiveKey(activeKey);
  };

  const { TabPane } = Tabs;

  return (
    <Row>
      <Col>
        <div>
          {isTabletOrMobileDevice && (
            <>
              <Col span={24}>
                <p style={{ fontSize: "110%" }}>
                  <HomeOutlined /> AY BAZLI GRAFİK
                </p>
                <hr></hr>
                <br></br>
              </Col>
              <Tabs
                style={{ marginLeft: "2%" }}
                onChange={handleChange}
                activeKey={activeKey}
              >
                {currencyTRList.length === 0
                  ? null
                  : currencyTRList.map((item, index) => {
                      return (
                        <TabPane
                          tab={<span>{item.currency}</span>}
                          key={item.currencyId}
                        >
                          {ContactSideBar(item.currency)}
                        </TabPane>
                      );
                    })}
              </Tabs>
            </>
          )}
          {isDesktopOrLaptop && (
            <>
              <Col span={24}>
                <p style={{ fontSize: "120%", marginTop: -5 }}>
                  <HomeOutlined /> AY BAZLI GRAFİK
                </p>
              </Col>
              <Tabs
                style={{ marginLeft: "2%" }}
                onChange={handleChange}
                activeKey={activeKey}
              >
                {currencyTRList.length === 0
                  ? null
                  : currencyTRList.map((item, index) => {
                      return (
                        <TabPane
                          tab={<span>{item.currency}</span>}
                          key={item.currencyId}
                        >
                          {ContactSideBar(item.currency)}
                        </TabPane>
                      );
                    })}
              </Tabs>
            </>
          )}
        </div>
      </Col>
    </Row>
  );
};

export default ChartsReport;
